var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"large-image-box",class:{
    'large-image-closed': !_vm.showLargeImage,
    'large-image-open': _vm.showLargeImage,
  }},[_c('span',{staticClass:"close",on:{"click":_vm.toggleImage}},[_vm._v("×")]),_c('img',{staticClass:"large-image",attrs:{"src":_vm.mutableUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }